// Libraries
import { action, computed } from "mobx";

// Core
import { ViewModelBase } from "Core/ViewModels";
import { FieldType } from "Core/Utils/Utils";

// Custom
import { isNullOrUndefined } from "Custom/Utils/Utils";
import { Server } from "Custom/Globals/AppUrls";
import { ProductSelectorModel } from "Custom/Models/Domain/ProductSelector/ProductSelectorModel";
import { StoresInstance } from "Custom/Stores/Stores";
import { ErrorStore } from "Custom/Stores/Domain";

export class GuaranteesViewModel extends ViewModelBase {
    private productSelectorModel: ProductSelectorModel;
    public errorStore: ErrorStore = StoresInstance.domain.ErrorStore;

    constructor(productSelectorModel: ProductSelectorModel) {
        super({});

        this.productSelectorModel = productSelectorModel;
    }

    @computed
    public get guarantees(): string[] {
        const retVal: string[] = [];

        if (!isNullOrUndefined(this.productSelectorModel.Products.productSelection)) {
            // Roof system guarantee.
            if (
                this.productSelectorModel.Products.productSelection.value === "id_roofsystem_only" ||
                this.productSelectorModel.Products.productSelection.value === "id_roofandgutter"
            ) {
                retVal.push(this.productSelectorModel.RoofSystem.getProductSelection.guarantee);

                // Delglaze guarantee.
                if (this.productSelectorModel.RoofSystem.DelglazeModel.productRequired) {
                    retVal.push("Delglaze rooflight coating system");
                }
            }

            // Gutter system guarantee.
            if (
                this.productSelectorModel.Products.productSelection.value === "id_guttersystem_only" ||
                this.productSelectorModel.Products.productSelection.value === "id_roofandgutter"
            ) {
                retVal.push(this.productSelectorModel.GutterSystem.productSelection.guarantee);
            }
        }

        return retVal;
    }

    @action
    public calculateQuote = async (): Promise<void> => {
        const errors = await this.productSelectorModel.Validate();

        if (errors.length === 0) {
            this.generateQuote();
        }
    };

    @action
    private generateQuote = async (): Promise<void> => {
        try {
            const apiResult = await this.Post<any>(Server.Api.Quote.CalculateQuote, this.productSelectorModel.toDto());

            if (apiResult.wasSuccessful) {
                this.productSelectorModel.Quote.fromDto(apiResult.payload);
            } else {
                // Error
                this.errorStore.SetErrorMessage("Calculate Quote", "There appears to be an issue getting your quote.", "Please try again later or talk to support");
            }
        } catch (exception) {
            // Catch
            this.errorStore.SetErrorMessage("Calculate Quote", "There appears to be an issue the quote for you.", "Please try again later or talk to support");
        } finally {
            // Finally
        }
    };

    // #region Viewmodel Boilerplate

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    public isFieldValid(fieldName: keyof FieldType<any>): boolean {
        return true;
    }

    // #endregion Viewmodel Boilerplate
}
